<template>
  <div ref="recaptchaContainer"></div>
</template>

<script>
export default {
  name: "Recaptcha",
  props: {
    siteKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      widgetId: null,
      checkInterval: null,
    };
  },
  mounted() {
    this.initRecaptcha();
  },
  beforeUnmount() {
    if (this.checkInterval) clearInterval(this.checkInterval);
  },
  methods: {
    initRecaptcha() {
      if (this.widgetId !== null) return;

      if (typeof window.turnstile === "undefined" || typeof window.turnstile.render === "undefined") {
        this.checkInterval = setInterval(() => {
          if (typeof window.turnstile !== "undefined" && typeof window.turnstile.render !== "undefined") {
            clearInterval(this.checkInterval);
            this.renderRecaptcha();
          }
        }, 300);
      } else {
        this.renderRecaptcha();
      }
    },

    renderRecaptcha() {
      if (!this.$refs.recaptchaContainer) return;

      if (this.widgetId !== null) return;

      this.widgetId = window.turnstile.render(this.$refs.recaptchaContainer, {
        sitekey: this.siteKey,
        callback: this.emitVerify,
        "expired-callback": this.emitExpired,
        "error-callback": this.emitError,
      });
    },

    emitVerify(token) {
      this.$emit("verify", token);
    },

    emitExpired() {
      this.$emit("verify", null);
    },

    emitError() {
      this.$emit("verify", null);
    },

    reset() {
      if (this.widgetId !== null && typeof window.turnstile !== "undefined") {
        window.turnstile.reset(this.widgetId);
        this.$emit("verify", null);
      }
    },
  },
};
</script>
